<template>

</template>

<script>

export default {
    name: 'Contact',

    watch: {
        '$route.name': function () {
          this.showRoute = this.$route.name;
          this.getPage(); // Re-fetch data when route changes
        },
    },
    created() {
        this.showRoute = this.$route.name
    },
    mounted() {
        this.getPage();
        const location = this.$route.query.location;
        console.log('Location from query:', location); // Debugging line

    },
 methods: {
        getPage(address) {
            var pageSlug = this.showRoute
            this.$axios.get(address ? address : "/api/" + pageSlug).then(response => {
                this.page = response.data;
                this.blurbs = response.data[11];
                this.$emit("route-data-ready");
            });
        },
    },
};

</script>
